import { PasswordInputFieldProps } from "@/types/common";
import { Field, Input, InputGroup } from "@chakra-ui/react";
import ViewIcon from "@/assets/ViewIcon.svg";
import ViewOff from "@/assets/ViewOff.svg";

const PasswordInputField = ({
  label,
  name,
  value,
  error,
  touched,
  show,
  onToggle,
  onChange,
}: PasswordInputFieldProps) => (
  <Field.Root invalid={touched && Boolean(error)}>
    <Field.Label>{label}</Field.Label>
    <InputGroup
      endElement={
        <img
          src={show ? ViewOff : ViewIcon}
          onClick={onToggle}
          style={{ cursor: "pointer" }}
          alt={show ? "Hide password" : "Show password"}
        />
      }
    >
      <Input
        id={name}
        name={name}
        type={show ? "text" : "password"}
        value={value}
        onChange={onChange}
        required
        placeholder={label}
        borderRadius={15}
        size="lg"
      />
    </InputGroup>
    {error && touched && <Field.ErrorText>{error}</Field.ErrorText>}
  </Field.Root>
);

export default PasswordInputField;
